import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import {
  LayoutContainer,
  Layouts,
  Modal,
  ModalDivider,
  ModalHeader,
  TabContainer,
  Wrapper,
} from "./styles";
import { FlexContainer, Subtitle } from "../../../styles";

import Pallette from "../../PalletteIcon";
import { FiArrowRight } from "react-icons/fi";

import Button from "../../Button";
import ColorButtons from "../../Shapes/ColorsButtons";
import SquareShape from "../../Shapes/Squares";
import HorizontalRectangleShape from "../../Shapes/Horizontal Rectangles";
import VerticalRectangleShape from "../../Shapes/Vertical Rectangles";
import { Tabs } from "antd";

export default function Layout({ setLayout, nextStep, defaultColor }) {
  const [open, setOpen] = useState(false);
  const [currentColor, setCurrentColor] = useState(defaultColor);
  const [selected, setSelected] = useState(null);

  const handleOpenModal = (number) => {
    setOpen(true);
    setSelected(number);
  };

  const onCancel = () => {
    setOpen(false);
    setSelected(null);
  };

  const onAdvance = () => {
    setLayout({
      color: currentColor,
      layout: selected,
    });
    setOpen(false);
    nextStep();
  };

  return (
    <LayoutContainer>
      <Subtitle marginTop="32px" marginBottom="24px">
        <FormattedMessage id={"ai_creator.tab1.label"} />
      </Subtitle>
      <ColorButtons
        currentColor={currentColor}
        setCurrentColor={setCurrentColor}
        center
        border
      />

      {currentColor && (
        <Layouts currentColor={Boolean(defaultColor)}>
          {[...Array(10).keys()].map((i) => (
            <Wrapper
              key={i}
              onClick={() => handleOpenModal(i + 1)}
              currentColor={Boolean(defaultColor)}
              index={i}
            >
              <SquareShape
                shape={i + 1}
                size={330}
                variantColor={currentColor}
              />
            </Wrapper>
          ))}
        </Layouts>
      )}

      <LayoutSelectModal
        open={open}
        onCancel={onCancel}
        onAdvance={onAdvance}
        color={currentColor}
        selected={selected}
      />
    </LayoutContainer>
  );
}

function LayoutSelectModal({ open, onCancel, onAdvance, color, selected }) {
  return (
    <Modal
      footer={""}
      open={open}
      centered={true}
      onCancel={onCancel}
      closable={false}
    >
      <div>
        <ModalHeader>
          <div>
            <Pallette />
            <p>
              <FormattedMessage id={"ai_creator.layout.select"} />
            </p>
          </div>
        </ModalHeader>
        <ModalDivider />

        <Tabs defaultActiveKey="1" centered>
          <Tabs.TabPane tab="1080 x 1350" key="1">
            <TabContainer>
              <SquareShape size={292} variantColor={color} shape={selected} />
            </TabContainer>
          </Tabs.TabPane>
          <Tabs.TabPane tab="1200 x 628" key="2">
            <TabContainer>
              <HorizontalRectangleShape
                size={292 + 164.25 + 16}
                variantColor={color}
                shape={selected}
              />
            </TabContainer>
          </Tabs.TabPane>
          <Tabs.TabPane tab="1080 x 1920" key="3">
            <TabContainer>
              <VerticalRectangleShape
                size={164.25}
                variantColor={color}
                shape={selected}
              />
            </TabContainer>
          </Tabs.TabPane>
        </Tabs>
        <FlexContainer direction={"column"} gap={"6.55px"}>
          <Button
            icon={<FiArrowRight size={20} />}
            onClick={onAdvance}
            size={"modal"}
            label={"foward"}
          />
          <Button
            size={"modal"}
            theme={"secondary"}
            onClick={onCancel}
            label={"return"}
          />
        </FlexContainer>
      </div>
    </Modal>
  );
}
